import PropTypes from 'prop-types';

import map from 'lodash/fp/map';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const ValuesBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-image: ${({ bg }) => `url(${bg.desktop.src})`};
  text-align: center;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center center;
  min-height: 700px;
  height: 100vh;
  max-height: 1080px;
  padding: 100px;
  ${legacyTheme.breakpoints.match('sm')} {
    background-image: ${({ bg }) => `url(${bg.mobile.src})`};
    min-height: 640px;
    height: auto;
    padding: 40px;
  }
`;

const ValuesHeader = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 27px;
  ${legacyTheme.breakpoints.match('sm')} {
    max-width: 240px;
  }
`;

const Separator = styled.hr`
  width: 90%;
  border-bottom: 1px solid ${theme.colors.neutral[100]};
  margin: 19px 0 75px 0;
  ${legacyTheme.breakpoints.match('sm')} {
    margin: 19px 0 45px 0;
  }
`;

const ValuesList = styled.div`
  max-width: 1200px;
  display: inline-flex;
  text-align: center;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: ${legacyTheme.spacing.s80};
  ${legacyTheme.breakpoints.match('md')} {
    gap: ${legacyTheme.spacing.s48};
  }
  ${legacyTheme.breakpoints.match('sm')} {
    flex-direction: column;
  }
`;

const Title = styled(Typography)`
  margin-bottom: ${legacyTheme.spacing.s8};
  font-weight: bold;
  font-size: 30px;
  line-height: 40px;
  ${legacyTheme.breakpoints.match('sm')} {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Value = styled.div`
  width: 270px;
`;

const Values = ({ content: { header, background, list } }) => {
  return (
    <ValuesBlock bg={background}>
      <ValuesHeader color="white" variant="h2r-mono">
        {header}
      </ValuesHeader>
      <Separator />
      <ValuesList>
        {map(({ title, titleEl, subtitleEl }) => (
          <Value key={title}>
            <Title color="white" variant="h2r-mono">
              {titleEl}
            </Title>
            <Typography color="white" variant="p1">
              {subtitleEl}
            </Typography>
          </Value>
        ))(list)}
      </ValuesList>
    </ValuesBlock>
  );
};

Values.propTypes = {
  content: PropTypes.shape({
    header: PropTypes.string,
    background: PropTypes.shape({
      desktop: PropTypes.shape({}),
      mobile: PropTypes.shape({}),
    }),
    list: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        titleEl: PropTypes.element,
        subtitleEl: PropTypes.element,
      })
    ),
  }).isRequired,
};

Values.defaultProps = {};

export default Values;
